import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Groups = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M8.86358 1.96948C6.28327 1.96948 4.18555 4.06721 4.18555 6.64751C4.18555 9.17857 6.16509 11.2271 8.7454 11.3157C8.82418 11.3058 8.90297 11.3058 8.96206 11.3157C8.98176 11.3157 8.99161 11.3157 9.0113 11.3157C9.02115 11.3157 9.02115 11.3157 9.031 11.3157C11.5522 11.2271 13.5318 9.17857 13.5416 6.64751C13.5416 4.06721 11.4439 1.96948 8.86358 1.96948Z"
      fill="#8FB6FF"
    />
    <path
      d="M13.8661 13.9354C11.1183 12.1036 6.63726 12.1036 3.86984 13.9354C2.61908 14.7725 1.92969 15.9051 1.92969 17.1164C1.92969 18.3278 2.61908 19.4505 3.85999 20.2778C5.23878 21.2036 7.0509 21.6664 8.86302 21.6664C10.6751 21.6664 12.4873 21.2036 13.8661 20.2778C15.107 19.4407 15.7964 18.318 15.7964 17.0968C15.7865 15.8854 15.107 14.7627 13.8661 13.9354Z"
      fill="#8FB6FF"
    />
    <path
      d="M19.6864 7.22858C19.844 9.13919 18.4849 10.8134 16.6038 11.0399C16.594 11.0399 16.594 11.0399 16.5841 11.0399H16.5546C16.4955 11.0399 16.4364 11.0399 16.3872 11.0596C15.4319 11.1089 14.5554 10.8036 13.8955 10.2422C14.9099 9.33616 15.491 7.97707 15.3728 6.49979C15.3038 5.70207 15.0281 4.97328 14.6144 4.35283C14.9887 4.1657 15.422 4.04752 15.8652 4.00813C17.7955 3.8407 19.519 5.27858 19.6864 7.22858Z"
      fill="#8FB6FF"
    />
    <path
      d="M21.6561 16.3385C21.5773 17.2938 20.9667 18.1211 19.9425 18.6824C18.9576 19.2241 17.7167 19.4801 16.4857 19.4506C17.1948 18.8104 17.6084 18.0127 17.6872 17.1658C17.7857 15.9445 17.2046 14.7726 16.0425 13.837C15.3826 13.315 14.6145 12.9014 13.7773 12.5961C15.9539 11.9658 18.6917 12.3892 20.3758 13.7483C21.2819 14.4771 21.7448 15.393 21.6561 16.3385Z"
      fill="#8FB6FF"
    />
  </svg>
)

export default withDefaultStyles(Groups)
